import React, { type ForwardedRef, forwardRef } from 'react';

import { AnimatePresence } from 'framer-motion';

import { type TextAreaHookOptions } from '@pkg/primitives';

import { Skeleton, SkeletonLabel, StaticLabel, StyledUserName } from './UserName.style';

export interface UserNameStaticProps {
    id?: string;
    value?: TextAreaHookOptions['initialValue'];
    loading?: boolean;
}

function UserNameStaticComponent(
    { id, value, loading = false }: UserNameStaticProps,
    ref: ForwardedRef<HTMLDivElement>,
) {
    const safeValue = value || '…';

    const skeletonMarkup = loading ? (
        <Skeleton key="UserNameStatic-Skeleton">
            <SkeletonLabel />
        </Skeleton>
    ) : null;

    return (
        <StyledUserName ref={ref} id={id}>
            <StaticLabel $loading={loading}>{safeValue}</StaticLabel>
            <AnimatePresence>{skeletonMarkup}</AnimatePresence>
        </StyledUserName>
    );
}

export const UserNameStatic = forwardRef(UserNameStaticComponent);
